import { AxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'

import { axiosAuthentication, axiosEntitiesApi, axiosUsers } from '../../config/axios'
import { isRedirectAvaiable } from '../../redirect/shared/redirectValidation'
import { controllerAuthentication } from './AuthController'
import { checkUserEmailVerify } from '../../main/home/services/HomeAction'
// import Notification, { type } from "../../shared/toast/Toast";

export const authenticationService = async (
    email: string,
    password: string,
    history: any,
    setLoading?: any,
    dispatch?: any,
) => {
    try {
        const axiosRequest1: AxiosRequestConfig = {
            url: 'signin',
            method: 'post',
            data: {
                email,
                password,
                domain: 'cuidate-web',
            },
        }
        const { data: data1 } = await axiosAuthentication(axiosRequest1)
        const resp = controllerAuthentication(1, data1)
        localStorage.setItem('token', resp?.token1)

        const axiosRequest2: AxiosRequestConfig = {
            url: 'v5.0.1/api',
            method: 'post',
            data: {
                fname: 'userIsInEntities',
                service: 'users',
                user_id: resp?.id,
                domain: 'cuidate-web',
            },
            headers: { authorization: resp?.token },
        }
        const { data: data2 } = await axiosEntitiesApi(axiosRequest2)
        const resp2 = controllerAuthentication(2, data2)

        const axiosRequest3: AxiosRequestConfig = {
            url: 'v5.0.1/api',
            method: 'post',
            data: {
                fname: 'getEntity',
                service: 'users',
                entity_id: resp2?.id,
            },
            headers: { authorization: resp?.token },
        }
        const { data: data3 } = await axiosEntitiesApi(axiosRequest3)
        const resp3 = controllerAuthentication(3, data3)

        const axiosRequest4: AxiosRequestConfig = {
            url: 'v5.0.1/api',
            method: 'post',
            data: {
                fname: 'getUser',
                user_id: resp?.id,
            },
            headers: { authorization: resp?.token },
        }

        const { data: data4 } = await axiosUsers(axiosRequest4)
        const resp4 = controllerAuthentication(4, data4)

        const isAvaiable = await isRedirectAvaiable(history)
        // console.log('isAvaiable', isAvaiable)
        localStorage.setItem(
            'user',
            JSON.stringify({
                usuario: { ...resp, ...resp4 },
                entidad: resp2,
                estilo: resp3,
            }),
        )
        if (isAvaiable) toast.success('Bienvenido estudiante')
        // return Notification( type.success, 'Bienvenido estudiante');

        const emailStatus = await checkUserEmailVerify()
        localStorage.setItem('emailStatus', emailStatus)

        setLoading && setLoading(false)
        dispatch({ type: 'AUTH_USER', payload: data4 })
        // return history.push('/dashboard')
    } catch (error) {
        console.log(error)
        setLoading && setLoading(false)
        // Notification( type.danger, 'Credenciales Inválidas' );
        toast.error('Credenciales Inválidas')
    }
}

export const registerService = async (
    user: any,
    history: any,
    dispatch: any,
    setLoading: any,
) => {
    const { name, password, email, lastname, birthdate } = user

    return axiosUsers({
        url: '/signup',
        method: 'post',
        data: {
            name,
            lastname,
            password,
            email,
            birthdate,
            rol: 'user',
            roles_entity: ['estudiante'],
            domain: 'cuidate-web',
            url: 'www.cuidate.com.pe',
        },
    })
        .then(() => {
            authenticationService(email, password, history, setLoading, dispatch)
        })
        .catch((e) => {
            setLoading && setLoading(false)
            if (e?.response?.data?.message) {
                toast.error(e.response.data.message)
            } else {
                toast.error('Hubo un error inesperado')
            }
            // return Notification( type.danger, e.response.data.message );
            // Notification( type.danger, 'Hubo un error inesperado' );
        })
}

export const recoverPasswordService = async (email: string) => {
    let token: string = ''

    await axiosUsers({
        url: '/auth/recover-password',
        method: 'post',
        data: { email },
    })
        .then(({ data }) => {
            token = data.token
        })
        .catch((e) => {
            if (e?.response?.data?.message) toast.error(e.response.data.message)
            // return Notification( type.danger, e.response.data.message );
            // Notification( type.danger, 'Hubo un error inesperado' );
            toast.error('Hubo un error inesperado')
        })

    return token
}

export const changePasswordService = async (password: string, token: string) => {
    let success: boolean = true

    await axiosUsers({
        url: '/v5.0.1/api',
        method: 'post',
        data: {
            fname: 'resetPassword',
            password,
        },
        headers: { authorization: `Bearer ${token}` },
    })
        .then(({ data }) => {})
        .catch((e) => {
            success = false
            // Notification( type.danger, 'Hubo un error inesperado' );
            toast.error('Hubo un error inesperado')
        })

    return success
}

export const verifyTokenExpiration = async (token: string) => {
    let expired: boolean = false

    await axiosUsers({
        url: '/v5.0.1/api',
        method: 'post',
        data: { fname: 'tokenIsValid' },
        headers: { authorization: `Bearer ${token}` },
    }).catch((e) => {
        expired = true
        // if( e?.response?.data?.message ) return Notification( type.danger, e.response.data.message );
        // Notification( type.danger, 'Hubo un error inesperado' );
    })

    return expired
}
